import { mainSiteUrl } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <div className="rounded-3xl overflow-hidden bg-accent-100/50">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20woman%20browsing%20fashion%20items%20on%20a%20laptop%20at%20a%20minimal%20wooden%20desk%2C%20surrounded%20by%20neatly%20folded%20garments%20in%20warm%20neutral%20tones%2C%20soft%20natural%20light%20from%20a%20large%20window%2C%20cozy%20cream%20interior%20with%20a%20warm%20throw%20blanket%2C%20editorial%20lifestyle%20photography%20with%20organic%20atmosphere&width=600&height=700&seq=testimonial-v2-001&orientation=portrait"
                alt="LitBuy user organizing purchases"
                className="w-full h-auto rounded-3xl"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <p className="text-xs font-label uppercase tracking-[0.2em] text-foreground-500 mb-4">
              User Feedback
            </p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Trusted by Thousands
              <br />
              <span className="text-foreground-400">of Style Buyers</span>
            </h2>

            <blockquote className="mt-8 text-base md:text-lg text-foreground-600 leading-relaxed italic">
              &ldquo;Using litbuy spreadsheet has completely transformed how I manage 
              my fashion purchases. The organizational framework is intuitive, and the 
              tracking features save me hours every week. I can finally see all my orders, 
              compare prices, and make smarter buying decisions in one place.&rdquo;
            </blockquote>

            <p className="mt-5 text-sm font-label font-semibold text-foreground-800">
              &mdash; Verified Buyer
            </p>

            <div className="mt-8 flex items-center gap-3">
              <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>

            <div className="mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 text-sm font-label font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                Join thousands of happy shoppers
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}